import { createFileRoute } from '@tanstack/react-router';

import QuoteImporterPdfSupplierPortalPage from '@/areas/quote-requests/SupplierPortal/QuoteImporterPdfSupplierPortalPage';
import { canAccessSupplierPortal } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/supplier-portal/quote-requests/$quoteRequestId/pdf-importer')({
    staticData: { access: { permissions: canAccessSupplierPortal }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <QuoteImporterPdfSupplierPortalPage {...pathParams} />;
}
